
import { Component, Vue, Prop } from 'vue-property-decorator';
import UserLogin from '@/app/components/session/UserLogin.vue';
import { BrandingImageType } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    UserLogin,
  },
})
export default class LoginView extends Vue {
  $refs!: {
    userLogin: UserLogin;
  };

  @Prop({ default: '' }) redirectTo!: string;

  @Prop({ default: '' }) redirectToQuery!: string;

  private currentStage = '';

  created() {
    /**
     * Clearing session for the use case where a logged in user goes back
     * to the login screen while with a registration session
     */
    if (this.authStore.hasRegistrationSession) {
      this.authStore.logout();
    }
  }

  get authStore() {
    return useAuthStore();
  }

  get splashLogoLink() {
    let out = this.$theme.val?.logos.find((l) => l.type === BrandingImageType.SPLASH_IMAGE)?.link;
    return out;
  }

  resendCode() {
    this.$refs.userLogin.refreshOtpCode();
  }

  click() {
    this.$toast.success('Password reset succesful.');
  }

  onLoginSuccess() {
    if (this.authStore.isUnverifiedSelfRegister) {
      this.$router.push('/register');
      return;
    }
    let path = this.authStore.isClientUser ? '/dashboard' : '/admin';
    let query = {};
    try {
      query = JSON.parse(this.redirectToQuery);
    } catch (e) {}
    if (this.redirectTo) {
      path = this.redirectTo;
    }
    this.$router.push({ path, query });
  }
}
